export const makePartnersList = (response) => {
    const partnersList = [];
    const mappingTitle = {
        [i18next.t('makePartnersList.mappingTitle.subcontractor.key')]:
            i18next.t('makePartnersList.mappingTitle.subcontractor.value'),
        [i18next.t('makePartnersList.mappingTitle.supplier.key')]:
            i18next.t('makePartnersList.mappingTitle.supplier.value'),
        [i18next.t('makePartnersList.mappingTitle.customer.key')]:
            i18next.t('makePartnersList.mappingTitle.customer.value'),
        [i18next.t('makePartnersList.mappingTitle.employee.key')]:
            i18next.t('makePartnersList.mappingTitle.employee.value'),
        [i18next.t('makePartnersList.mappingTitle.investor.key')]:
            i18next.t('makePartnersList.mappingTitle.investor.value'),
        [i18next.t('makePartnersList.mappingTitle.other.key')]:
            i18next.t('makePartnersList.mappingTitle.other.value'),
    };

    response.data.forEach((partner) => {
        const optionParent = {
            title: mappingTitle[partner.name],
            value: partner.type,
            isHead: true,
            isDisabled: true,
            fullName: partner.name,
            children: [],
        };
        partnersList.push(optionParent);

        partner.list.forEach((listItem) => {
            const option = {
                value: listItem.guid,
                title: listItem.name,
                fullName: listItem.full_name,
                partner: listItem,
                parent: partner.type,
            };
            partnersList.push(option);
            optionParent.children.push(option);
        });
    });

    return partnersList;
};
